<template>
    <div class="widget-bottom" v-show="active">
        <div id="store-chooser-wrapper">
        
        </div>
      <div class="store-chooser animated" :class="{slideInUp: active}">
        <!--标题-->
        <h1 class="chooser-header">
          <div class="nav-title">请选择所在城市</div>
          <div class="right-menu" @click="cancelHandler"></div>
        </h1>
        <!--导航-->
        <ul class="tab-nav">
          <li :class="{selected: navItem.valueField === selectedField}"
              v-for="(navItem, index) in fields" v-text="navItem.selectedItem[navItem.labelField]"
              @click="switchNav(index)">
          </li>
        </ul>
        <!--主体-->
        <div class="container">
          <div class="content" :style="translateStyle">
            <div class="tab" v-for="(field, index) in fields">
              <div class="scroll">
                <ul>
                  <li :class="{selected: field.selectedItem[field.valueField] === item[field.valueField]}"
                      v-for="item in field.items" @click="drillDown(index, item)"
                      v-text="item[field.labelField]">
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import vueResource from 'vue-resource';
    import CONF from '@/app.conf.json';
    import LISTPROVINCE from '@/commons/listProvince';

    import _ from 'lodash';

    // Promise 垫片
    require('core-js/fn/promise');

    export default {
        name: 'AddressWidget',
        props: [
            'isActive',
            'initSelect'
        ],
        data () {

            //视图模型
            return {
                selectedField: 'mdmId',
                // 城市组件是否显示
                active: this.isActive,
                // 省、市、区数据
                fields: [
                    {
                        valueField: 'mdmId',
                        labelField: 'name',
                        selectedItem: {},
                        items: []
                    },
                    {
                        valueField: 'lesId',
                        labelField: 'name',
                        selectedItem: {},
                        items: []
                    }
                ],
                translateStyle: {
                    "-webkit-transform": "translate(0px, 0px) translateZ(0px)"
                }
            }
        },
        computed: {

            /*fullAddress () {

                if (!!this.fields[2].selectedItem.distName) {

                    return (this.fields[0].selectedItem.name + ',' + this.fields[1].selectedItem.cityName + ',' + this.fields[2].selectedItem.distName);
                }
            }*/
        },
        watch: {
          isActive(val, oldVal) {
            this.active = val
          }
        },
        mounted () {

            this.init();

        },
        methods: {

            init() {
            	  
                let _this = this;

                // 先检查是否传入默认选中的选项
                if (typeof _this.initSelect !== 'undefined' && _this.initSelect.length > 0) {

                    _.forEach(_this.initSelect, (value, index, arr) => {

                        let valueField = _this.fields[index].valueField,
                            labelField = _this.fields[index].labelField;

                        if (!_.has(value, valueField) || !_.has(value, labelField)) {

                            console.info('初始化StoreWidget参数错误或参数不全');
                        } else {
                            _this.fields[index].selectedItem = value;
                        }
                    });

                    //_this.tellParent();
                }

                // 初始化省数据（本地文件）
                _this.fields[0].items = LISTPROVINCE;
                _.isEmpty(_this.fields[0].selectedItem) && (_this.fields[0].selectedItem = LISTPROVINCE[0]);

                _this.queryCityByProvCode(_this.fields[0].selectedItem.mdmId).then(cityData => {
                    _this.fields[1].items = cityData;
                    _.isEmpty(_this.fields[1].selectedItem) && (_this.fields[1].selectedItem = cityData[0]);

                    return cityData[0];
                });
            },

            /**
             * [事件监听] 下钻
             * @param {Number} index
             * @param {Object} item
             * @return null
             */
            drillDown(index, item) {

                let _this = this,
                    drillDownIdx = index + 1;

                _this.fields[index].selectedItem = item;

                switch (drillDownIdx) {
                    case 1:

                        _this.queryCityByProvCode(item.mdmId).then(data => {

                            _this.fields[drillDownIdx].items = data;

                            !_this.checkHasItem(data, _this.fields[drillDownIdx].selectedItem) &&
                            (_this.fields[drillDownIdx].selectedItem = data[0]);

                            _this.switchNav(drillDownIdx);

                            //return data[0];
                        });
                        break;
                    default:
                        _this.tellParent();
                        _this.cancelHandler();
                }
            },

            /**
             * 在指定的集合中查找某一项是否存在
             */
            checkHasItem(itemList, checkItem) {

                _.find(itemList, item => {

                    return checkItem === item;
                })
            },

            /**
             * [事件绑定]
             */
            clickInput() {
                this.active = !this.active;
            },
            /**
             * [事件绑定] 取消
             */
            cancelHandler() {
                this.active = false;
//                document.removeEventListener('touchmove', eventDefault, false);
            },

            /**
             * [事件绑定] tab切
             */
            switchNav(index) {

                let _this = this,
                    currentField = _this.fields[index],
                    htmlStyle = getComputedStyle(document.getElementsByTagName("html")[0]) || {},
                    width = -index * parseFloat(htmlStyle["width"]);

                _this.selectedField = currentField.valueField;

                _this.translateStyle = {
                    "-webkit-transform": `translate(${width}px, 0px) translateZ(0px)`
                };
            },

            /**
             * 把子组件数据传到父组件
             */
            tellParent() {

                let _this = this;

                _this.$emit('listenChild', [
                  _this.fields[0].selectedItem,
                  _this.fields[1].selectedItem
                ]);
            },

            /**
             * 根据省code查询市
             * @param: {String} code
             * @return Promise
             */
            queryCityByProvCode(code) {

              let url = CONF.API.queryCityList + code + '-gotCityByProvCode.html';

              return new Promise((resolve, reject) => {
                Vue.http.jsonp(url, {
                  jsonpCallback : 'gotCityByProvCode'
                }).then(data => {

                  if (data.body.cities.length > 0) {

                    resolve(data.body.cities);
                  } else {
                    reject(new Error(`${CONF.API.queryCityList}接口错误`));
                  }
                }, data => {
                  reject(new Error(data));
                });
              });
            }
        }
    }
</script>

<style scoped>
    .widget-top {
        height: 88px;
        line-height: 88px;
        color: #313131;
        border-bottom: 1px solid #DCDCDC;
        background: #fff;
    }
    .widget-left {
        width: 3.75rem;
        display: block;
        font-size: .6rem;
        padding-left: .5rem;
        float: left;
    }
    .widget-right {
        position: relative;
        overflow: hidden;

        input {
            border: 0;
            outline: none;
            height: 70px;
            line-height: 70px;
            color: #353d44;
            padding: .5rem 0;
            width: 100%;
            font-size: .6rem;
            display: block;
            margin-top: 8px;
        }

        >  span {
               display: block;
               width: 10px;
               height: 10px;
               background: #000;
               display: none;
           }

        .db-arrow {
            width: .28rem;
            height: .28rem;
            border: 1px solid #909090;
            transform: rotate(-135deg);
            border-right: 0;
            border-bottom: 0;
            display: inline-block;
            position: absolute;
            right: .5rem;
            top: 50%;
            margin-top: -.14rem;
            background: transparent;

            &.active {
                 transform: rotate(-315deg);
             }
        }
    }

    .widget-bottom {
        height: auto;
        background: #f2f2f2;
    }

    #store-chooser-wrapper {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: hsla(0, 0%, 0%, .5);
        z-index: 10;
    }

    .store-chooser {
        position: fixed;
        width: 100%;
        background-color: #f0f0f0;
        height: auto;
        bottom: 0;
        left: 0;
        z-index: 20;
    }

    .chooser-header {
        position: relative;
        background-color: #FFF;
        border: 0;
        height: 1.76rem;
        line-height: 1.76rem;
        border-bottom: 1px solid #dcdcdc;

        .nav-title {
            font-size: 28px;
            width: 60%;
            margin: 0 auto;
            color: #333;
            text-align: center;
            word-break: break-all;
            white-space: nowrap;
            overflow: hidden;
        }

        .right-menu {
            position: absolute;
            top: -2.4rem;
            right: 0;
            /*width: 33px;*/
            /*height: 33px;*/
            /*margin-top: -16px;*/
            /*right: 20px;*/
            /*background: url("../../assets/close33.png") 0 0 no-repeat;*/
            /*background-size: 33px 33px;*/

            &::after {
                content: '';
                display: block;
                width: 2rem;
                height: 2.8rem;
                background: url("../../assets/close-addr.png") center top no-repeat;
                background-size: 1rem 2.8rem;
            }

        }
    }
    .tab-nav {
        display: block;
        width: 100%;
        height: 1.76rem;
        line-height: 1.76rem;
        z-index: 1;

        li {
            width: 50%;
            float: left;
            background-color: #fff;
            color: #353d44;
            font-size: .52rem;
            text-align: center;
            border-bottom: .12rem solid #fff;

            &.selected {
                border-bottom-color: #eda200;
                color: #f29400;
                font-size: .6rem;
            }

        }
    }
    .container {
        width: 100%;
        height: 11.5rem;

        .content {
            display: -webkit-box;
            width: 200%;
            height: 100%;
            transition: all .2s linear;
        }

        div.tab {
            -webkit-overflow-scrolling: touch;
            -webkit-box-flex: 1;
            height: 100%;
            width: 100%;
            overflow: auto;
            overflow-x: hidden;
        }

        .scroll {
            width: 100%;
            height: auto;
        }

        li {
            height: auto;
            padding: .41rem .56rem;
            font-size: .6rem;
            border-bottom: 1px solid #dcdcdc;

            &.selected {
                background-color: #dcdcdc;
                color: #f29400;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/commons/City.vue